import React from "react";

import { ColorError } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { StyledAccordion } from "../Accordion";
import { ObjectTitle } from "../ObjectTitle";
import { componentSort } from "../utils";

import { DeleteKeyValueLine } from "./DeleteKeyValueLine";

export const DeletedObject = ({ from, k }: { from: any; k: string }) => {
  if (Array.isArray(from) && !from.length) {
    return null;
  }

  return (
    <Grid
      container
      item
      direction={"row"}
      rowSpacing={1}
      className={"deleted-object"}
    >
      <StyledAccordion
        defaultExpanded={false}
        color={ColorError.main}
        title={<ObjectTitle data={from} k={k} action={"Deleted"} />}
        content={
          <Grid container item direction={"column"} rowSpacing={1}>
            {from && typeof from === "object" ? (
              Object.keys(from).length ? (
                Object.entries(from)
                  .filter(([key, value]) => key !== "listKey")
                  .map(([k, value], index) => {
                    if (value && typeof value === "object") {
                      return {
                        type: "deletedObject",
                        element: (
                          <DeletedObject
                            key={`${k}-${index}`}
                            k={k}
                            from={value}
                          />
                        ),
                      };
                    } else {
                      return {
                        type: "deleteKeyValueLine",
                        element: (
                          <DeleteKeyValueLine
                            key={`${k}-${index}`}
                            k={k}
                            value={value}
                          />
                        ),
                      };
                    }
                  })
                  .sort(componentSort)
                  .map((i) => i.element)
              ) : (
                "Not Set"
              )
            ) : (
              <DeleteKeyValueLine
                k={k}
                value={from}
                dontFormat={true}
                key={k}
              />
            )}
          </Grid>
        }
      />
    </Grid>
  );
};
